module.exports = __webpack_public_path__ + "img/assistencia.e74a8601.png";